export default __webpack_public_path__ + "static/media/svg1.274acb45.svg";